export class Checklist {
    id: string;
    name: string;
    critical: boolean = false;
    active: boolean = true;
    fleet: string;
}
